<template>
  <div class="org-mng">
    <div class="search">
      <div class="search-input">
        <el-input
          placeholder="搜索报名服务单位"
          v-model="orgname"
          @keyup.enter.native="(page = 1), getOrgList(true)"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
      </div>
    </div>
    <div class="org-lst">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="org-item" v-for="(org, i) in orgList" :key="i">
          <img :src="org.logo" alt="" />
          <div class="org-infos">
            <div class="stu-num">学员{{ org.peoNum }}</div>
            <div class="info">
              <div>{{ org.name }}</div>
              <p>{{ org.address || "" }}</p>
              <!-- <p>{{ org.link }} {{ org.linkPhone }}</p> -->
              <p>注册时间：{{ org.registerTime }}</p>
            </div>
            <div class="people-num">
              <!-- <span>{{ org.peoNum }}位学员</span> -->

              <span>{{ org.link }} {{ org.linkPhone }}</span>
              <div class="btn" @click="makeQrcodeCard(org)">
                <div>扫</div>
                <p>二维码</p>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <van-overlay :show="orgQrCodeView" @click="orgQrCodeView = false">
      <div class="code-area" id="qr_code_content_org">
        <m-loading :loading="creating"></m-loading>
        <!-- <div class="code-org-name">{{ checkOrg.name }}</div>
        <img class="qr-img" :src="checkOrg.qrCode" alt="" />
        <p>学员扫此码可绑定此报名服务单位</p> -->

        <!-- <img
          class="down-ico"
          src="../../assets/images/home/download-qr-ico.png"
          alt=""
        /> -->
        <!-- <div class="save-code" @click="saveQRcode(checkOrg.qrCode)">
          保存二维码
        </div> -->
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { getPageInstitution } from "@/utils/api/channel";
import { MakeCard } from "../../utils/make-canvas-card";
const getStrList = (str, len = 10) => {
  var arr = [];
  for (let i = 0; i < str.length / len; i++) {
    let a = str.slice(len * i, len * (i + 1));
    arr.push(a);
  }
  return arr;
};
export default {
  data() {
    return {
      // 搜索报名服务单位名称
      orgname: "",
      loading: false,
      finished: false,
      page: 0,
      pageSize: 10,
      // 显示组织二维码卡片
      orgQrCodeView: false,
      // 组织列表
      orgList: [],
      qrCode: "",
      // 选择的组织
      checkOrg: null,
      // 制作卡片loading
      creating: false
    };
  },
  methods: {
    onLoad() {
      this.page++;
      this.getOrgList(this.page === 1);
    },
    getOrgList(init = false) {
      this.loading = true;
      const p = {
        pageNo: this.page,
        pageSize: this.pageSize,
        name: this.orgname
      };
      if (init) this.orgList = [];
      if (!this.orgname) {
        delete p.name;
      }
      getPageInstitution(p).then((res) => {
        if (res.success) {
          const loadData = res.data.records.map((e) => {
            return {
              id: e.id,
              name: e.name,
              address: e.contactAdress || "-",
              link: e.personCharge,
              linkPhone: e.contactsTel,
              peoNum: e.studentNum,
              registerTime: e.addTime,
              qrCode: e.qrCode
                .replace(
                  "https://motherland-h5.oss-cn-beijing.aliyuncs.com",
                  "/oss-h5"
                )
                .replace(
                  "https://motherlandh5.oss-cn-beijing.aliyuncs.com",
                  "/ossh5"
                ),
              logo: e.logo
            };
          });
          this.orgList.push(...loadData);
        } else {
          this.loading = false;
          this.finished = true;
        }
        this.loading = false;
        if (this.page * this.pageSize >= res.data.total) {
          this.finished = true;
        }
      });
    },
    // 查看二维码
    viewQrCode(org) {
      this.checkOrg = org;
      this.orgQrCodeView = true;
    },
    // 制作二维码卡片
    async makeQrcodeCard(org) {
      this.creating = true;
      this.orgQrCodeView = true;
      let width = 320;
      let height = 399;
      const title = `${org.name}`;
      let sliceStrArr = getStrList(title);
      let titleFontSize = 18;
      let drawArr = [];
      if (sliceStrArr.length > 2) {
        sliceStrArr = getStrList(title, 12);
        titleFontSize = 15;
      }
      if (sliceStrArr.length > 2) {
        sliceStrArr = getStrList(title, 15);
        titleFontSize = 12;
      }
      if (sliceStrArr.length > 2) {
        drawArr.push({
          type: "text",
          center: true,
          y: 53,
          color: "#fff",
          fontSize: 18,
          weight: "700",
          text: `报名服务单位注册码`
        });
      } else {
        sliceStrArr.forEach((e, i) => {
          if (i)
            drawArr.push({
              type: "text",
              center: true,
              y: 63,
              color: "#fff",
              fontSize: titleFontSize,
              weight: "700",
              text: e
            });
          else
            drawArr.push({
              type: "text",
              center: true,
              y: 43,
              color: "#fff",
              fontSize: titleFontSize,
              weight: "700",
              text: e
            });
        });
      }
      let options = {
        el: "qr_code_content_org",
        width,
        height,
        multiple: 2,
        className: "card",
        els: [
          {
            type: "img",
            url: require("../../assets/images/home/qr-code-show-head.png"),
            x: 0,
            y: 0,
            w: width,
            h: 101,
            round: false
          },
          ...drawArr,
          // {
          //   type: "text",
          //   center: true,
          //   y: 53,
          //   color: "#fff",
          //   fontSize: titleFontSize,
          //   weight: "700",
          //   text: `${org.name}-注册码`
          // },
          {
            type: "roundrect",
            x: 76,
            y: 133,
            w: 168,
            h: 168,
            r: 16,
            color: "#6CDD8F",
            lineWidth: 6
          },
          {
            type: "img",
            url: org.qrCode,
            x: (width - 148) / 2,
            y: 144,
            w: 148,
            h: 148,
            round: false
          },
          {
            type: "text",
            center: true,
            y: 320,
            color: "#999",
            fontSize: 14,
            text: "学员扫此码可绑定报名服务单位"
          },
          {
            type: "text",
            center: true,
            y: 360,
            color: "#999",
            fontSize: 14,
            text: "长按二维码即可保存或分享"
          }
        ],
        success: () => {
          this.creating = false;
        }
      };
      this.$nextTick(() => {
        let makeCard = new MakeCard(options);
        makeCard.create();
      });
    }
  }
};
</script>
<style lang="scss">
.org-mng {
  .search {
    .search-input {
      .el-input__inner {
        background-color: #f2f2f2;
        border: none;
        border-radius: 20px;
      }
    }
  }
  .van-overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    .code-area {
      width: 320px;
      height: 399px;
      background-color: #fff;
      // background-image: url("../../assets/images/home/qr-code-show-head.png");
      background-position: 0 0;
      background-size: 320px 101px;
      background-repeat: no-repeat;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 16px;
      overflow: hidden;

      .code-org-name {
        margin-top: 38px;
        font-size: 18px;
        line-height: 25px;
        font-weight: 700;
        margin-top: 42px;
        color: #fff;
      }
      & > img {
        &.card {
          height: 100%;
          width: 100%;
        }
        &.qr-img {
          width: 168px;
          height: 168px;
          margin-top: 67px;
          border: 5px solid #6cdd8f;
          border-radius: 16px;
        }
        &.down-ico {
          width: 24px;
          height: 24px;
          margin-top: 23px;
        }
      }
      & > p {
        margin-top: 16px;
        color: #999999;
        font-size: 12px;
        margin-top: 12px;
      }
      .save-code {
        margin-top: 36px;
        width: 160px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        color: #fff;
        border-radius: 20px;
        background: linear-gradient(
          -90deg,
          rgba(55, 220, 141, 1) -15%,
          rgba(30, 191, 95, 1) 100%
        );
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.org-mng {
  max-width: 10rem;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: left;
  .search {
    width: 100%;
    height: 80px;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f2f2f2;
    .search-input {
      width: 100%;
      height: 40px;
    }
    border-bottom: 1px solid #f2f2f2;
  }
  .org-lst {
    flex: 1;
    overflow-y: scroll;
    padding: 0 20px;
    .org-item {
      padding: 12px 0px;
      display: flex;
      margin-bottom: 15px;
      height: 134px;
      img {
        width: 105px;
        height: 105px;
        border-radius: 4px;
      }
      .org-infos {
        flex: 1;
        margin-left: 10px;
        display: flex;
        flex-direction: column;
        position: relative;
        .stu-num {
          position: absolute;
          width: 56px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          border-radius: 10px 0px 10px 10px;
          color: #fff;
          background: #6cdd8f;
          right: 0;
          top: 0;
        }
        .info {
          flex: 1;
          display: flex;
          flex-direction: column;
          div {
            font-size: 16px;
            color: #333;
            line-height: 22px;
            margin-bottom: 4px;
            max-width: 160px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          p {
            font-size: 12px;
            margin-bottom: 2px;
            color: #666;
            max-width: 180px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .people-num {
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          span {
            font-size: 12px;
            color: #666;
          }
          .btn {
            display: flex;
            width: 38px;
            height: 46px;
            flex-direction: column;
            border-radius: 4px;
            overflow: hidden;
            div {
              flex: 1;
              color: #fff;
              background: #6cdd8f;
              font-size: 16px;
              text-align: center;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            p {
              width: 100%;
              height: 16px;
              line-height: 16px;
              text-align: center;
              color: #6cdd8f;
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}
</style>
